// src/components/Toast.jsx
import React, { useState, useEffect, useCallback } from 'react';

let _show = null;
export const toast = msg => _show && _show(msg);

export default function Toast() {
  const [msg,  setMsg]  = useState('');
  const [show, setShow] = useState(false);
  const [tid,  setTid]  = useState(null);

  const show_ = useCallback(m => {
    if (tid) clearTimeout(tid);
    setMsg(m); setShow(true);
    setTid(setTimeout(() => setShow(false), 12800));
  }, [tid]);

  useEffect(() => { _show = show_; return () => { _show = null; }; }, [show_]);

  return <div className={`toast${show ? ' show' : ''}`}>{msg}</div>;
}
